import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "../pageInside/Card";
import CardCircle from "../pageInside/CardCircle";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./SwiperProduct.css";
import useElakaySwiper from "./swiperSettings/useElakaySwiper";
import { legacyTableFrom } from "./swiperSettings/swiperSettingsModel";
import { getDefaultTitleStyle } from "../../utils/titleStyle";

const toCssColor = (v, alpha = 1) => {
  if (!v) return "transparent";

  const s = String(v).trim();

  // déjà un format CSS valide
  if (
    s.startsWith("#") ||
    s.startsWith("rgb(") ||
    s.startsWith("rgba(") ||
    s.startsWith("hsl(") ||
    s.startsWith("hsla(") ||
    s === "transparent"
  ) return s;

  // format "49, 0%, 80%"  -> hsla(49, 0%, 80%, alpha)
  if (s.includes("%") && s.includes(",")) return `hsla(${s}, ${alpha})`;

  // fallback
  return s;
};

const SwiperProduct = (props) => {
  const {
    infoSource,
    nameSlider,
    linkSlider,
    myStyles,
    ProductSwiper = [],
    currentShopId = null,
    circle = false,
    // Matrix Mode (circle sub-category sliders only): the parent's children
    // map { [childCategoryId]: products[] } when that parent has Matrix Mode
    // ON (All Categories page). null/undefined = default circle images.
    categoryMatrix = null,
    classLink,
    showB,
    wm0 = 2,
    wm640 = 3,
    wm768 = 4,
    wm1024 = 4,
    wm1200 = 5,
    showShopV = true,
    edit = false,
    // Swiper Settings: this instance's own per-device overrides (a Main /
    // Category Page section's props.swiperOptions). Absent = inherit.
    swiperOptions,

    // 🔗 LIEN — clé de traduction + styles
    linkText            = 'seeMore',      // clé dans languageAPI.Link
    linkFontFamily      = 'inherit',
    linkFontSize        = '0.9rem',
    linkFontWeight      = 500,
    linkFontStyle       = 'normal',
    linkLetterSpacing   = 'normal',
    linkTextTransform   = 'none',
    linkTextDecoration  = 'none',
    linkColor           = '#007399',
    linkHoverColor      = '#005577',
    linkBackgroundColor = 'transparent',
    linkPadding         = '0',
    linkBorderRadius    = '0',
    linkTextShadow      = 'none',
    linkClass           = '',

    // ============================================
    // 🎬 PROPS ANIMATION CONTAINER (0-32)
    // ============================================
    type_Animation = null, // "0_type_Animation" à "32_type_Animation"
    animation = false, // Rétrocompatibilité - ancien système
    backgroundColor = "#DCDCDC",
    containerFusion = false, // Fond, bordure et ombre transparents — fusionne le conteneur avec la page
    containerBorder = null, // ex: "1px solid #e5e7eb"
    containerBorderRadius = null, // ex: "12px"
    containerBoxShadow = null, // ex: "0 4px 20px rgba(0,0,0,0.08)"

    // ============================================
    // 🎨 PROPS TITRE - POLICE & STYLE
    // ============================================
    // Défauts non fixés en dur : voir getDefaultTitleStyle() (utils/titleStyle.js)
    // — AnimationSettings → General → "Default Title Styles" fournit la valeur
    // par défaut si aucune de ces props n'est explicitement passée.
    titleFontFamily, // Police du titre: "Arial", "Roboto", "Poppins", etc.
    titleFontSize, // "1.5rem", "2rem", "24px", etc.
    titleFontWeight, // Graisse: 400, 500, 600, 700, 800, 900
    titleFontStyle, // Style: "normal", "italic", "oblique"
    titleLetterSpacing, // Espacement lettres: "-1px", "0", "2px"
    titleLineHeight, // Hauteur de ligne: 1, 1.2, 1.5, "normal"
    titleTextTransform, // Transform: "none", "uppercase", "lowercase", "capitalize"
    titleTextAlign, // Alignement: "left", "center", "right"

    // ============================================
    // 🎨 PROPS TITRE - COULEURS
    // ============================================
    titleColor, // Couleur texte du titre
    titleTextShadow, // Ombre du texte

    // ============================================
    // 🎬 PROPS TITRE - ANIMATION (0-32)
    // ============================================
    titleAnimation = null, // "animated_0" à "animated_32" ou null pour désactiver
    titleAnimationColors = null, // { primary: "#...", accent: "#..." } ou null pour défaut

    // ============================================
    // 🎬 PROPS HEADER - ANIMATION (0-32)
    // ============================================
    headerAnimation = null, // "animated_0" à "animated_32" ou null pour désactiver
    headerAnimationColors = null, // { primary: "#...", accent: "#..." } ou null pour défaut

    // ============================================
    // 🎨 PROPS HEADER - STYLE
    // ============================================
    headerBackgroundColor = "transparent", // Couleur de fond du header
    headerPadding = null, // Padding personnalisé: "1rem", "10px 20px"
    headerMarginBottom = null, // Marge en bas: "1rem", "20px"

    // ============================================
    // 🎨 COULEURS D'ANIMATION GLOBALES
    // ============================================
    animationColors = {
      // Type 0 - Version originale (arc-en-ciel)
      "0_type_Animation": {
        primary: "#007399",
        accent: "#3b82f6",
        secondary: "#8b5cf6",
      },
      // Type 1 - Rose et Violet
      "1_type_Animation": {
        primary: "#e91e63",
        accent: "#9c27b0",
        light1: "#fce4ec",
        light2: "#f3e5f5",
      },
      // Type 2 - Vert et Jaune
      "2_type_Animation": {
        primary: "#4caf50",
        accent: "#ffeb3b",
        light1: "#e8f5e9",
        light2: "#fffde7",
      },
      // Type 3 - Orange et Rouge
      "3_type_Animation": {
        primary: "#ff9800",
        accent: "#f44336",
        light1: "#fff3e0",
        light2: "#ffebee",
      },
      // Type 4 - Bleu et Indigo
      "4_type_Animation": {
        primary: "#2196f3",
        accent: "#3f51b5",
        light1: "#e3f2fd",
        light2: "#e8eaf6",
      },
      // Type 5 - Cyan et Teal
      "5_type_Animation": {
        primary: "#00bcd4",
        accent: "#009688",
        light1: "#e0f7fa",
        light2: "#e0f2f1",
      },
      // Type 6 - Or et Bronze (Premium)
      "6_type_Animation": {
        primary: "#ffd700",
        accent: "#cd7f32",
        light1: "#fffde7",
        light2: "#fff8e1",
      },
      // Type 7 - Argent et Platine
      "7_type_Animation": {
        primary: "#c0c0c0",
        accent: "#e5e4e2",
        light1: "#fafafa",
        light2: "#f5f5f5",
      },
      // Type 8 - Neon Magenta et Cyan
      "8_type_Animation": {
        primary: "#ff00ff",
        accent: "#00ffff",
        light1: "#fff0ff",
        light2: "#e0ffff",
      },
      // Type 9 - Rainbow
      "9_type_Animation": {
        primary: "#ff0000",
        accent: "#00ff00",
        secondary: "#0000ff",
        tertiary: "#ffff00",
      },
      // Type 10 - Deep Purple et Lavender
      "10_type_Animation": {
        primary: "#673ab7",
        accent: "#b39ddb",
        light1: "#ede7f6",
        light2: "#d1c4e9",
      },
      // Type 11 - Lime et Chartreuse
      "11_type_Animation": {
        primary: "#cddc39",
        accent: "#8bc34a",
        light1: "#f9fbe7",
        light2: "#dcedc8",
      },
      // Type 12 - Pink et Fuchsia
      "12_type_Animation": {
        primary: "#e91e63",
        accent: "#9c27b0",
        light1: "#fce4ec",
        light2: "#f3e5f5",
      },
      // Type 13 - Amber et Honey
      "13_type_Animation": {
        primary: "#ffc107",
        accent: "#ffa000",
        light1: "#fff8e1",
        light2: "#ffecb3",
      },
      // Type 14 - Brown et Tan
      "14_type_Animation": {
        primary: "#795548",
        accent: "#bcaaa4",
        light1: "#efebe9",
        light2: "#d7ccc8",
      },
      // Type 15 - Blue Grey et Slate
      "15_type_Animation": {
        primary: "#607d8b",
        accent: "#90a4ae",
        light1: "#eceff1",
        light2: "#cfd8dc",
      },
      // Type 16 - Coral et Peach
      "16_type_Animation": {
        primary: "#ff7f50",
        accent: "#ffdab9",
        light1: "#fff5ee",
        light2: "#ffefd5",
      },
      // Type 17 - Blanc et Turquoise Premium
      "17_type_Animation": {
        primary: "#007399",
        accent: "#4facfe",
        light1: "#e8f4f8",
        light2: "#d4ecf7",
      },
      // Type 18 - Matrix Digital Rain
      "18_type_Animation": {
        primary: "#00ff41",
        accent: "#00c832",
        light1: "#0d1a0d",
        light2: "#001a00",
      },
      // Type 19 - Neon Glow
      "19_type_Animation": {
        primary: "#ff0080",
        accent: "#00ffff",
        light1: "#1a0a1a",
        light2: "#0a1a1a",
      },
      // Type 20 - Liquid Blob
      "20_type_Animation": {
        primary: "#667eea",
        accent: "#764ba2",
        light1: "#eef2ff",
        light2: "#faf5ff",
      },
      // Type 21 - Holographic / Prism
      "21_type_Animation": {
        primary: "#ff0080",
        accent: "#40e0d0",
        secondary: "#ff8c00",
        tertiary: "#8000ff",
      },
      // Type 22 - Electric Storm
      "22_type_Animation": {
        primary: "#ffff00",
        accent: "#ffc800",
        light1: "#1a1a2e",
        light2: "#16213e",
      },
      // Type 23 - Orbital / Sunset
      "23_type_Animation": {
        primary: "#ffc864",
        accent: "#ff9632",
        light1: "#fff8f0",
        light2: "#fff0e0",
      },
      // Type 24 - Water Ripples / Ocean
      "24_type_Animation": {
        primary: "#0096c8",
        accent: "#00c8fa",
        light1: "#e6f7ff",
        light2: "#ccefff",
      },
      // Type 25 - Smoke Rising
      "25_type_Animation": {
        primary: "#c8c8c8",
        accent: "#969696",
        light1: "#f5f5f5",
        light2: "#e0e0e0",
      },
      // Type 26 - Confetti Celebration
      "26_type_Animation": {
        primary: "#ff6b6b",
        accent: "#4ecdc4",
        secondary: "#ffe66d",
        tertiary: "#95e1d3",
      },
      // Type 27 - Sparkle Stars
      "27_type_Animation": {
        primary: "#ffffc8",
        accent: "#ffffff",
        light1: "#0c1445",
        light2: "#1a237e",
      },
      // Type 28 - Hexagon Grid / Tech Blue
      "28_type_Animation": {
        primary: "#3498db",
        accent: "#2ecc71",
        light1: "#ecf0f1",
        light2: "#bdc3c7",
      },
      // Type 29 - Triangle Pattern / Soft Pink
      "29_type_Animation": {
        primary: "#ff9a9e",
        accent: "#fad0c4",
        light1: "#fff5f5",
        light2: "#fff0ed",
      },
      // Type 30 - Morphing Square / Lavender
      "30_type_Animation": {
        primary: "#a18cd1",
        accent: "#fbc2eb",
        light1: "#f5f0ff",
        light2: "#fff0f8",
      },
      // Type 31 - Energy Burst
      "31_type_Animation": {
        primary: "#ff6464",
        accent: "#6464ff",
        light1: "#fff0f0",
        light2: "#f0f0ff",
      },
      // Type 32 - Northern Lights / Aurora
      "32_type_Animation": {
        primary: "#00ff80",
        accent: "#00c8ff",
        secondary: "#8000ff",
        light1: "#0c1445",
        light2: "#1a237e",
      },
    },
  } = props;
  const safeProducts = Array.isArray(ProductSwiper) ? ProductSwiper.filter(Boolean) : [];
  // Options: page instance > Animation Settings -> Swiper Settings > origin.
  // wm0..wm1200 passed by the page are that instance's own slides-per-view.
  const swp = useElakaySwiper("productSlider", {
    swiperOptions,
    legacyTable: legacyTableFrom({ wm0, wm640, wm768, wm1024, wm1200 }, { 0: 12, 568: 12, 768: 13, 1024: 14, 1200: 15 }),
    legacyExplicit: ["wm0", "wm640", "wm768", "wm1024", "wm1200"].some((key) => props[key] !== undefined),
    autoNavigation: Boolean(infoSource?.navigation),
    slideCount: safeProducts.length,
  });

  const sliderShow = safeProducts.length > 0;
const slideBg = toCssColor(props?.content_BackGroundColor, 1); // ou 0.12 si tu veux transparent

  // ============================================
  // 🎬 LOGIQUE ANIMATION CONTAINER
  // ============================================
  const getAnimationClass = () => {  
    
    if (animation === true || animation === "true") {
      return type_Animation || "0_type_Animation";
    }

    if (type_Animation) {
      const validTypes = Array.from({ length: 33 }, (_, i) => `${i}_type_Animation`);
      if (validTypes.includes(type_Animation)) {
        return type_Animation;
      }
    }
 
    return "";
  };

  const animationClass = getAnimationClass();
  const isAnimated = animationClass !== "";

    
  // ============================================
  // 🎬 LOGIQUE ANIMATION TITRE
  // ============================================
  const getTitleAnimationClass = () => {
    if (titleAnimation === false || titleAnimation === "none") {
      return "";
    }
    if (titleAnimation) {
      const validAnimations = Array.from({ length: 33 }, (_, i) => `animated_${i}`);
      if (validAnimations.includes(titleAnimation)) {
        return titleAnimation;
      }
    }
    // Si pas de titleAnimation spécifié mais container animé, utiliser l'animation correspondante
    // if (isAnimated && titleAnimation === null) {
    //   const typeNumber = animationClass.replace("_type_Animation", "");
    //   return `animated_${typeNumber}`;
    // }
    return "";
  };

  const titleAnimClass = getTitleAnimationClass();

  // ============================================
  // 🎬 LOGIQUE ANIMATION HEADER
  // ============================================
  const getHeaderAnimationClass = () => {
    if (headerAnimation === false || headerAnimation === "none") {
      return "";
    }
    if (headerAnimation) {
      const validAnimations = Array.from({ length: 33 }, (_, i) => `animated_${i}`);
      if (validAnimations.includes(headerAnimation)) {
        return headerAnimation;
      }
    }
    return "";
  };

  const headerAnimClass = getHeaderAnimationClass();


    // ============================================
  // 🎨 CLASSES CSS CONDITIONNELLES
  // ============================================
  const containerClass = `slider-product-wrapper ${animationClass}`
    // ? `slider-product-wrapper ${animationClass}`
    // : "slider-product-wrapper";

  const headerClass = headerAnimClass
    ? `slider-product-header ${headerAnimClass}`
    : "slider-product-header";

  const titleClass = titleAnimClass
    ? `slider-product-title ${titleAnimClass}`
    : "slider-product-title";

  // const swiperClass = isAnimated
  //   ? `slider-product-swiper ${animationClass}`
  //   : "slider-product-swiper";

   const swiperClass = circle
    ? `swiper_circle slider-product-swiper`
    : `slider-product-swiper `;

    //    const swiperClass = circle
    // ? `swiper_circle slider-product-swiper ${animationClass}`
    // : `mySwiper slider-product-swiper`;

  // ============================================
  // 🎨 OBTENIR LES COULEURS D'ANIMATION
  // ============================================
  const getCurrentColors = () => {
    if (!isAnimated) return null;
    return animationColors[animationClass] || animationColors["0_type_Animation"];
  };

  const colors = getCurrentColors();
  
  // ============================================
  // 🎨 STYLES INLINE
  // ============================================

  // Style de bordure / rayon / ombre du container
  const borderStyle = {
    ...(containerBorder && { border: containerBorder }),
    ...(containerBorderRadius && { borderRadius: containerBorderRadius }),
    ...(containerBoxShadow && { boxShadow: containerBoxShadow }),
  };

  // Style de fusion : fond, bordure et ombre transparents (le conteneur se fond avec la page)
  const fusionStyle = containerFusion
    ? { backgroundColor: "transparent", border: "none", boxShadow: "none" }
    : null;

  // Style du container
  const containerStyle = !isAnimated
    ? { backgroundColor, ...myStyles, ...borderStyle, ...fusionStyle }
    : { ...myStyles, ...borderStyle, ...fusionStyle };

  // CSS Variables pour les animations du container
  const animationStyle =
    isAnimated && colors
      ? {
          "--anim-primary": colors.primary,
          "--anim-accent": colors.accent,
          "--anim-secondary": colors.secondary || colors.primary,
          "--anim-tertiary": colors.tertiary || colors.accent,
          "--anim-light1": colors.light1 || "#f0f0f0",
          "--anim-light2": colors.light2 || "#e0e0e0",
          ...myStyles,
          ...borderStyle,
          ...fusionStyle,
        }
      : { ...myStyles, ...borderStyle, ...fusionStyle };

  // Style du Header
  const headerStyle = {
    backgroundColor: headerBackgroundColor,
    ...(headerPadding && { padding: headerPadding }),
    ...(headerMarginBottom && { marginBottom: headerMarginBottom }),
    // CSS Variables pour les couleurs d'animation du header
    ...(headerAnimClass &&
      headerAnimationColors && {
        "--header-anim-primary": headerAnimationColors.primary,
        "--header-anim-accent": headerAnimationColors.accent,
      }),
  };

  // Style du Titre — priorité : props explicites > AnimationSettings
  // "Default Title Styles" > défauts codés en dur (voir titleStyle.js).
  const titlePresentation = getDefaultTitleStyle(infoSource?.allSettings?.defaultTitleStyle, {
    fontFamily: titleFontFamily,
    fontSize: titleFontSize,
    fontWeight: titleFontWeight,
    fontStyle: titleFontStyle,
    letterSpacing: titleLetterSpacing,
    lineHeight: titleLineHeight,
    textTransform: titleTextTransform,
    textAlign: titleTextAlign,
    color: titleColor,
    textShadow: titleTextShadow,
  });
  const titleStyle = {
    ...titlePresentation.style,
    // CSS Variables pour les couleurs d'animation du titre
    ...(titleAnimClass &&
      titleAnimationColors && {
        "--anim-primary": titleAnimationColors.primary,
        "--anim-accent": titleAnimationColors.accent,
      }),
  };
// Style inline du lien:
const linkStyle = {
    fontFamily     : linkFontFamily,
    fontSize       : linkFontSize,
    fontWeight     : linkFontWeight,
    fontStyle      : linkFontStyle,
    letterSpacing  : linkLetterSpacing,
    textTransform  : linkTextTransform,
    textDecoration : linkTextDecoration,
    color          : linkColor,
    backgroundColor: linkBackgroundColor,
    padding        : linkPadding,
    borderRadius   : linkBorderRadius,
    textShadow     : linkTextShadow,
    '--link-hover-color': linkHoverColor, // CSS var pour le :hover
};

// Texte résolu via la clé de traduction:
const resolvedLinkText =
    infoSource?.laguangeElakay?.("Link", infoSource?.languageAPI)?.[linkText]
    || "See More";

  return (
    sliderShow && (
      <div
        className={containerClass}
        style={isAnimated ? animationStyle : containerStyle}
      >
        {/* Header */}
        {(nameSlider || linkSlider) && (
          <div className={headerClass} style={headerStyle}>
            {nameSlider ? (
              <h2 className={`${titleClass} ${titlePresentation.className}`} style={titleStyle} >{nameSlider}</h2>
            ) : null}
            {linkSlider ? (
              <Link
                className={`slider-link ${classLink || ""}`}
                to={linkSlider}
                 style={linkStyle}
              >
                {resolvedLinkText}  
              </Link>
            ) : null}
          </div>
        )}
        <Swiper
          key={swp.key}
          {...swp.swiperProps}
          style={{
            "--swiper-navigation-color": colors?.primary || "#007399",
            "--swiper-pagination-color": colors?.primary || "#0ea5e9",
             "--slide-bg": slideBg,
            ...swp.style,
          }}
          centeredSlidesBounds={circle} // ✅ empêche les slides de déborder
        className={`${swiperClass} ${swp.className}`}
        >
          {safeProducts.map((product, i) => (
            <SwiperSlide 
              key={i}
              className={`slider-product__slide slide-transparent ${isAnimated ? animationClass : ''}`}
            >
              {circle ? (
                <>
                  <CardCircle
                    infoSource={infoSource}
                    product={product}
                    matrixProducts={categoryMatrix ? (categoryMatrix[String(product?.supCategoryID?._id || "")] || []) : undefined}
                    // classCard0="d-flex justify-content-center"
                  />
                </>
              ) : (
                <Card
                  currentShopId={currentShopId}
                  infoSource={infoSource}
                  product={product}
                  CataID={
                    product?.categoriesID?.length > 0
                      ? product?.categoriesID[0]?.catID
                      : undefined
                  }
                  showB={showB}
                  classCard0="col p-0 card-transparent"
                  showShopV={showShopV}
                  edit={edit}
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    )
  );
};

export default SwiperProduct;
